export default __webpack_public_path__ + "static/media/Tracy_Kosolcharoen.56f1efc7.jpg";